import { render } from "./mClipPagination.vue?vue&type=template&id=28575230"
import script from "./mClipPagination.vue?vue&type=script&lang=js"
export * from "./mClipPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__